module.exports = __webpack_public_path__ + "static/media/black-texture.b8dd2112.jpg";